/* eslint-disable no-open-modules-imports */
import type { FeatureGroup } from 'feature/feature-helpers';
import { COMPOSITE } from 'feature/feature-helpers';
import { ChannelSettingsFeature } from 'open-modules/zdf/feature/channel-settings';
import { ChannelBaseFeature } from 'open-modules/zdf/feature/channels/channel-base';
import { ChannelSelectionModDashboardFeature } from 'open-modules/zdf/feature/channels/channel-selection';
import { ModDashboardSettingsFeature } from 'open-modules/zdf/feature/moddashboard-settings';

export const modDashboardFeatures: FeatureGroup[] = [
    COMPOSITE(ChannelBaseFeature, [ChannelSelectionModDashboardFeature]),
    COMPOSITE(ModDashboardSettingsFeature, [ChannelSettingsFeature]),
];

export const modDashboardDefaultConfig = {
    channelbase: false,
    channelassignment: false,
    channeldropdown: false,
    moddashboardsettings: false,
    channelsettings: false,
};
